/// <reference path="typings/jquery.d.ts" />
/// <reference path="typings/quarkplayer.d.ts" />
/// <reference path="commons/xhr.ts" />
/// <reference path="commons/cookie.ts" />
var WhichOne = /** @class */ (function () {
    function WhichOne() {
        this.setKey = false;
        this.containers = {
            competition: document.querySelector(".which-one"),
            step: document.querySelector(".which-one-step"),
            stepOption1: document.querySelector(".which-one-step .wo-option.option-1"),
            stepOption2: document.querySelector(".which-one-step .wo-option.option-2"),
            infoRow: document.querySelector(".which-one-info"),
            answered: document.querySelector(".which-one-answered"),
            before: document.querySelector(".which-one-item-wrapper"),
            beforeFigure1: document.querySelector(".which-one-item .wo-option.option-1"),
            beforeFigure2: document.querySelector(".which-one-item .wo-option.option-2"),
            headToHead: document.querySelectorAll(".head-to-head"),
            widget: document.querySelector(".which-one-widget"),
        };
        if (this.containers.competition) {
            this.elements = {
                question: this.containers.competition.querySelector(".which-one-title"),
                step: {
                    option1: {
                        input: this.containers.stepOption1.querySelector("input"),
                        label: this.containers.stepOption1.querySelector("label"),
                        figure: this.containers.stepOption1.querySelector(".wo-figure"),
                        title: this.containers.stepOption1.querySelector(".title"),
                        voteCount: this.containers.stepOption1.querySelector(".wo-vote-count"),
                        votePercent: this.containers.stepOption1.querySelector(".wo-vote-percent")
                    },
                    option2: {
                        input: this.containers.stepOption2.querySelector("input"),
                        label: this.containers.stepOption2.querySelector("label"),
                        figure: this.containers.stepOption2.querySelector(".wo-figure"),
                        title: this.containers.stepOption2.querySelector(".title"),
                        voteCount: this.containers.stepOption2.querySelector(".wo-vote-count"),
                        votePercent: this.containers.stepOption2.querySelector(".wo-vote-percent")
                    }
                },
                before: {
                    figure1: {
                        figure: this.containers.beforeFigure1.querySelector("img"),
                        title: this.containers.beforeFigure1.querySelector(".title"),
                        voteCount: this.containers.beforeFigure1.querySelector(".wo-vote-count"),
                        votePercent: this.containers.beforeFigure1.querySelector(".wo-vote-percent")
                    },
                    figure2: {
                        figure: this.containers.beforeFigure2.querySelector("img"),
                        title: this.containers.beforeFigure2.querySelector(".title"),
                        voteCount: this.containers.beforeFigure2.querySelector(".wo-vote-count"),
                        votePercent: this.containers.beforeFigure2.querySelector(".wo-vote-percent")
                    },
                    title: this.containers.before.querySelector(".wo-title")
                }
            };
            this.formId = this.containers.competition.getAttribute("data-id");
            this.formUrl = this.containers.competition.getAttribute("data-url");
            this.formPageId = this.containers.competition.getAttribute("data-page-id");
            this.imageUrl = this.containers.competition.getAttribute("data-image-url");
        }
        this.init();
    }
    WhichOne.prototype.init = function () {
        var _this = this;
        if (this.containers.widget) {
            var widgetRadios = this.containers.widget.querySelectorAll("input[type='radio']");
            widgetRadios.forEach(function (radio) {
                radio.addEventListener("change", function () {
                    _this.stepControl("widgetchoice", radio);
                });
            });
            this.containers.widget.querySelector(".wo-skip").addEventListener("click", function () {
                window.location.href = _this.containers.widget.getAttribute("data-url");
            });
        }
        if (!this.containers.competition) {
            return false;
        }
        var url = "/action/contest_which_questions/" + this.formId;
        if (this.formPageId) {
            url += "?pageId=" + this.formPageId;
        }
        if (this.formId) {
            this.createData(url);
        }
        var radios = this.containers.step.querySelectorAll("input[type='radio']");
        radios.forEach(function (radio) {
            radio.addEventListener("change", function () {
                _this.stepControl("choice", radio);
            });
        });
        this.containers.infoRow.querySelector(".wo-skip").addEventListener("click", function () {
            _this.stepControl("skip");
        });
        this.containers.answered.querySelector(".skip").addEventListener("click", function () {
            _this.stepControl("skip");
        });
        if (this.containers.headToHead.length > 0) {
            this.containers.headToHead.forEach(function (headToHead) {
                headToHead.querySelectorAll(".head-to-head-item").forEach(function (item) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var questionId = item.getAttribute("data-id");
                        var parent = item.closest(".head-to-head");
                        if (parent.hasAttribute("data-title")) {
                            var url_1 = _this.formUrl + "?page=" + parent.getAttribute("data-title");
                            if (questionId) {
                                url_1 += "#" + questionId;
                            }
                            window.location.href = url_1;
                            return;
                        }
                        if (questionId) {
                            _this.stepControl("goto", null, questionId);
                        }
                    });
                });
            });
        }
    };
    WhichOne.prototype.stepControl = function (eventType, element, questionId) {
        if (element === void 0) { element = null; }
        if (questionId === void 0) { questionId = null; }
        if (eventType === "widgetchoice") {
            this.nextScreen(element, true);
            return;
        }
        this.containers.competition.classList.remove("step");
        this.containers.competition.classList.remove("answered");
        this.containers.competition.classList.remove("final");
        if (eventType === "choice") {
            this.nextScreen(element);
        }
        if (eventType === "skip") {
            this.skipScreen();
        }
        if (eventType === "goto") {
            this.gotoScreen(questionId);
        }
    };
    WhichOne.prototype.nextScreen = function (element, widget) {
        var _this = this;
        if (widget === void 0) { widget = false; }
        if (!widget) {
            this.containers.before.classList.add("visible");
            this.containers.competition.classList.remove("before");
        }
        var choiceId = element.value;
        var questionId = element.name;
        var cookie = Cookie.getCookie("contestWhich");
        var timestamp = new Date();
        var time = timestamp.getTime();
        time += 60 * 60 * 24 * 365 * 1000;
        timestamp.setTime(time);
        if (cookie) {
            var cookieArr = cookie.split(',');
            if (cookieArr.indexOf(questionId) === -1) {
                cookieArr.push(questionId);
                cookie = cookieArr.join(',');
                document.cookie = 'contestWhich=' + cookie + '; expires=' + timestamp.toUTCString() + '; path=/';
            }
        }
        else {
            document.cookie = 'contestWhich=' + questionId + '; expires=' + timestamp.toUTCString() + '; path=/';
        }
        var postData = {
            choiceId: choiceId,
            id: widget ? this.containers.widget.getAttribute("data-form-id") : this.formId,
            questionId: questionId
        };
        var url = "/action/contest_which";
        this.postData(url, postData).then(function (data) {
            if (widget) {
                window.location.href = _this.containers.widget.getAttribute("data-url");
                return;
            }
            if (data) {
                element.checked = false;
                _this.setBeforeData(data);
            }
        });
        if (!widget) {
            this.setStepData();
        }
    };
    WhichOne.prototype.skipScreen = function () {
        this.setStepData();
    };
    WhichOne.prototype.gotoScreen = function (questionId) {
        var offset = this.containers.competition.offsetTop;
        if (window.innerWidth < 768) {
            offset -= document.querySelector(".navbar").scrollHeight;
        }
        else {
            offset -= 25;
        }
        window.scrollTo({ top: offset, behavior: "smooth" });
        this.setStepData(questionId);
    };
    WhichOne.prototype.getData = function (url) {
        return $.ajax({
            type: "GET",
            url: url,
            dataType: "json"
        }).then(function (data) {
            return data;
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error: ", errorThrown);
        });
    };
    WhichOne.prototype.postData = function (url, postData) {
        return $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(postData),
            dataType: "json"
        }).then(function (data) {
            return data;
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error: ", errorThrown);
        });
    };
    WhichOne.prototype.createData = function (url) {
        var _this = this;
        this.getData(url).then(function (data) {
            if (!data) {
                console.error("data: ", data);
                return false;
            }
            _this.data = data;
            var questionId = null;
            var hash = window.location.hash;
            if (hash) {
                var hashQuestion_1 = hash.replace("#", "");
                var question = _this.data.find(function (item) {
                    return item.id == hashQuestion_1;
                });
                if (question) {
                    questionId = question.id;
                }
            }
            _this.setStepData(questionId);
            var cookie = Cookie.getCookie("contestWhich");
            var answeredQuestions = cookie ? cookie.split(',') : [];
            if (answeredQuestions.length > 0) {
                // get last answered question
                var lastQuestionId_1 = answeredQuestions[answeredQuestions.length - 1];
                var lastQuestion = _this.data.find(function (item) {
                    return item.id == lastQuestionId_1;
                });
                if (lastQuestion) {
                    _this.containers.before.classList.add("visible");
                    _this.setBeforeData(lastQuestion);
                }
            }
        });
    };
    WhichOne.prototype.setStepData = function (questionId) {
        var _this = this;
        if (questionId === void 0) { questionId = null; }
        var dataIndex = 0;
        var cookie = Cookie.getCookie("contestWhich");
        var answeredQuestions = cookie ? cookie.split(',') : [];
        var allAnswered = false;
        var answered = false;
        if (questionId) {
            if (answeredQuestions.indexOf(questionId) === -1) {
                dataIndex = this.data.findIndex(function (item) {
                    return item.id == questionId;
                });
            }
            else {
                answered = true;
            }
        }
        else {
            var unansweredQuestions = this.data.filter(function (item) {
                return answeredQuestions.indexOf(item.id) === -1;
            });
            if (unansweredQuestions.length > 0) {
                var randomIndex = Math.floor(Math.random() * unansweredQuestions.length);
                var randomQuestion_1 = unansweredQuestions[randomIndex];
                dataIndex = this.data.findIndex(function (item) {
                    return item.id == randomQuestion_1.id;
                });
            }
            else {
                allAnswered = true;
            }
        }
        if (allAnswered) {
            this.containers.competition.classList.remove("step");
            this.containers.competition.classList.remove("answered");
            this.containers.competition.classList.add("final");
            return;
        }
        if (answered) {
            this.containers.competition.classList.remove("step");
            this.containers.competition.classList.remove("final");
            this.containers.competition.classList.add("answered");
            return;
        }
        var imgBaseUrl = this.imageUrl + "/400x0/";
        this.elements.question.innerText = this.data[dataIndex].title;
        this.elements.step.option1.input.name = this.data[dataIndex].id;
        this.elements.step.option1.input.value = this.data[dataIndex].choices[0].id;
        this.elements.step.option1.input.id = this.data[dataIndex].choices[0].id;
        this.elements.step.option1.label.htmlFor = this.data[dataIndex].choices[0].id;
        this.elements.step.option1.figure.style.background = "url(" + imgBaseUrl + this.data[dataIndex].choices[0].file + ") center center / cover no-repeat";
        this.elements.step.option1.title.innerText = this.data[dataIndex].choices[0].title;
        this.elements.step.option1.voteCount.innerText = this.data[dataIndex].choices[0].answerCount + " Oy";
        this.elements.step.option1.votePercent.innerText = "%" + this.data[dataIndex].choices[0].answerPercent;
        this.elements.step.option2.input.name = this.data[dataIndex].id;
        this.elements.step.option2.input.value = this.data[dataIndex].choices[1].id;
        this.elements.step.option2.input.id = this.data[dataIndex].choices[1].id;
        this.elements.step.option2.label.htmlFor = this.data[dataIndex].choices[1].id;
        this.elements.step.option2.figure.style.background = "url(" + imgBaseUrl + this.data[dataIndex].choices[1].file + ") center center / cover no-repeat";
        this.elements.step.option2.title.innerText = this.data[dataIndex].choices[1].title;
        this.elements.step.option2.voteCount.innerText = this.data[dataIndex].choices[1].answerCount + " Oy";
        this.elements.step.option2.votePercent.innerText = "%" + this.data[dataIndex].choices[1].answerPercent;
        if (!this.setKey) {
            this.containers.competition.classList.add("step");
            this.setKey = true;
            return;
        }
        setTimeout(function () {
            _this.containers.competition.classList.add("step");
        }, 500);
    };
    WhichOne.prototype.setBeforeData = function (data) {
        var _this = this;
        var imgBaseUrl = this.imageUrl + "/355x416/";
        this.elements.before.figure1.figure.src = imgBaseUrl + data.choices[0].file;
        this.elements.before.figure1.figure.alt = data.choices[0].title;
        this.elements.before.figure1.title.innerText = data.choices[0].title;
        this.elements.before.figure1.voteCount.innerText = data.choices[0].answerCount + " Oy";
        this.elements.before.figure1.votePercent.innerText = "%" + data.choices[0].answerPercent;
        this.elements.before.figure2.figure.src = imgBaseUrl + data.choices[1].file;
        this.elements.before.figure2.figure.alt = data.choices[1].title;
        this.elements.before.figure2.title.innerText = data.choices[1].title;
        this.elements.before.figure2.voteCount.innerText = data.choices[1].answerCount + " Oy";
        this.elements.before.figure2.votePercent.innerText = "%" + data.choices[1].answerPercent;
        this.elements.before.title.innerText = data.title;
        setTimeout(function () {
            _this.containers.competition.classList.add("before");
        }, 300);
    };
    return WhichOne;
}());
var whicOne = new WhichOne();
//# sourceMappingURL=whichOne.js.map